import { useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';

// assets
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useSnackbar } from 'notistack';
import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
import { auth } from 'apis';

// ===========================|| FIREBASE - REGISTER ||=========================== //

const ForgotPassword = ({ ...others }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    //  const customization = useSelector((state) => state.customization);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const params = useParams();
    const navigate = useNavigate();
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleClickShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = async ({ password }, { setSubmitting }) => {
        try {
            /* const instance = axios.create({
                baseURL: `${process.env.REACT_APP_BASE_URL}`,
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const bodyParameters = {
                password,
                reset_token: params.token
            }; */
            await auth.resetPassword({ password, reset_token: params.token });
            enqueueSnackbar('O κωδικός άλλαξε με επιτυχία', {
                variant: 'success'
            });
            setSubmitting(false);
            navigate('/login');
        } catch (error) {
            enqueueSnackbar('Κάτι πήγε λάθος, προσπαθήστε ξανά', {
                variant: 'error'
            });
            setSubmitting(false);
        }
    };

    return (
        <>
            <Formik
                initialValues={{
                    password: '',
                    confirmPassword: '',
                    submit: null
                }}
                validationSchema={Yup.object().shape({
                    password: Yup.string()
                        .min(8, 'Ο κωδικός πρέπει να είναι τουλάχιστον 8 χαρακτήρες')
                        .max(255)
                        .required('Password is required'),
                    confirmPassword: Yup.string()
                        .max(255)
                        .when('password', {
                            is: (val) => val && val.length,
                            then: Yup.string().oneOf([Yup.ref('password')], 'Both password need to be the same')
                        })
                        .required('Password confirmation is required')
                })}
                onSubmit={handleSubmit}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                    <form noValidate onSubmit={handleSubmit} {...others}>
                        <FormControl
                            fullWidth
                            error={Boolean(touched.password && errors.password)}
                            sx={{ ...theme.typography.customInput }}
                        >
                            <InputLabel htmlFor="outlined-adornment-password-reset">Κωδικός</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password-reset"
                                type={showPassword ? 'text' : 'password'}
                                value={values.password}
                                name="password"
                                label="Password"
                                onBlur={handleBlur}
                                autoComplete=""
                                onChange={(e) => {
                                    handleChange(e);
                                }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                            size="large"
                                        >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                inputProps={{}}
                            />
                            {touched.password && errors.password && (
                                <FormHelperText error id="standard-weight-helper-text-password-reset">
                                    {errors.password}
                                </FormHelperText>
                            )}
                        </FormControl>
                        <FormControl
                            fullWidth
                            error={Boolean(touched.password && errors.password)}
                            sx={{ ...theme.typography.customInput }}
                        >
                            <InputLabel htmlFor="outlined-adornment-password-reset-confirm">Επιβεβαίωση κωδικού</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password-reset-confirm"
                                type={showConfirmPassword ? 'text' : 'password'}
                                value={values.confirmPassword}
                                name="confirmPassword"
                                label="confirmPassword"
                                onBlur={handleBlur}
                                autoComplete=""
                                onChange={(e) => {
                                    handleChange(e);
                                }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowConfirmPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                            size="large"
                                        >
                                            {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                inputProps={{}}
                            />
                            {touched.confirmPassword && errors.confirmPassword && (
                                <FormHelperText error id="standard-weight-helper-text-password-reset-confirm">
                                    {errors.confirmPassword}
                                </FormHelperText>
                            )}
                        </FormControl>
                        {errors.submit && (
                            <Box sx={{ mt: 3 }}>
                                <FormHelperText error>{errors.submit}</FormHelperText>
                            </Box>
                        )}

                        <Box sx={{ mt: 2 }}>
                            <AnimateButton>
                                <Button
                                    disableElevation
                                    disabled={isSubmitting}
                                    fullWidth
                                    size="large"
                                    type="submit"
                                    variant="outlined"
                                    color="secondary"
                                >
                                    ΑΛΛΑΓΗ ΚΩΔΙΚΟΥ
                                </Button>
                            </AnimateButton>
                        </Box>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default ForgotPassword;
